import { Outlet } from 'react-router-dom';
import { ThemeToggle } from './ThemeToggle';

/** Centered, unauthenticated layout for sign in / register. */
export function AuthLayout() {
  return (
    <div className="relative grid min-h-screen place-items-center bg-page px-6 py-10">
      <div className="absolute right-5 top-5">
        <ThemeToggle />
      </div>
      <Outlet />
    </div>
  );
}
